

import { Category, CategoryStatus } from "./category.types";
import axiosInstance from "../Instance/axiosInstance";
import { environment } from "../../environments/environment";

//  Get All Categories
export const getCategories = async (): Promise<Category[]> => {
  const { data } = await axiosInstance.get<{ data: Category[] }>("/Admin/categories");
  return Array.isArray(data.data) ? data.data : [];
};
export const getCategoriess = async (): Promise<Category[]> => {
  const { data } = await axiosInstance.get<{ data: Category[] }>("/activeCategories");
  return Array.isArray(data.data) ? data.data : [];
};


//  Create Category — now sends FormData instead of JSON
export const createCategory = async (payload: {
  name: string;
  description?: string;
  status: string;
  metalTypeId: string;
  image?: File | null;
}) => {
  const formData = new FormData();

  formData.append("name", payload.name);
  formData.append("status", payload.status);
  formData.append("metalTypeId", payload.metalTypeId);
  formData.append("createdByRole", "admin"); 

  if (payload.description) {
    formData.append("description", payload.description);
  }

  if (payload.image) {
    formData.append("image", payload.image);
  }

  const { data } = await axiosInstance.post(
    "/admin/Create_Category",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return data;
};

export const updateCategoryApi = async (
  id: number,
  payload: {
    name: string;
    description: string;
    status: string;

    metalTypeId?: string | number;

    image?: File | null;
  }
): Promise<any> => {

  const formData = new FormData();

  formData.append("name", payload.name);

  formData.append("description", payload.description);

  formData.append("status", payload.status);

  // ✅ Metal Type
  if (payload.metalTypeId) {
    formData.append(
      "metalTypeId",
      String(payload.metalTypeId)
    );
  }

  // ✅ Image
  if (payload.image) {
    formData.append("image", payload.image);
  }

  const response = await axiosInstance.put(
    `/category/${id}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return response.data;
};

// ✅ Get Category By ID
export const getCategoryById = async (id: number): Promise<Category> => {
  const { data } = await axiosInstance.get<{ data: any }>(
    `/category/${id}`
  );

  const category = data.data;
  const rawImage =
    category.image || category.image_url || category.imageUrl || null;
  const fullImage =
    rawImage && typeof rawImage === "string"
      ? rawImage.startsWith("http")
        ? rawImage
        : `${environment.fileUrl}/${rawImage.replace(/^\/+/, "")}`
      : null;

  return {
    id: category.id,
    name: category.name,
    description: category.description,
    status: category.status,
    image: fullImage,
    categortystatus:
      (category.categortystatus as CategoryStatus) ||
      (category.status?.toUpperCase() === "ACTIVE"
        ? CategoryStatus.ACTIVE
        : CategoryStatus.INACTIVE),
  };
};

// ✅ Update Category Status
export const updateCategoryStatusApi = async (
  id: number,
  payload: { categortystatus: string }
): Promise<void> => {
  try {
    await axiosInstance.put(`/category/status/${id}`, payload);
    // console.log("✅ Category status updated successfully!");
  } catch (error: any) {
    console.error(
      "❌ Error updating category status:",
      error.response?.data || error.message
    );
    throw error;
  }
};


// ✅ Approve Category API
export const approveCategoryApi = async (
  categoryId: number
): Promise<any> => {

  try {

    const response = await axiosInstance.patch(
      `/admin/category/approve/${categoryId}`
    );

    return response.data;

  } catch (error: any) {

    console.error(
      "❌ Error approving category:",
      error.response?.data || error.message
    );

    throw error;
  }
};


// ✅ Delete Category (Soft Delete)
export const deleteCategoryApi = async (
  id: number
): Promise<void> => {
  try {
    await axiosInstance.delete(`/admin/category/${id}`);
    // console.log("✅ Category deleted successfully!");
  } catch (error: any) {
    console.error(
      "❌ Error deleting category:",
      error.response?.data || error.message
    );
    throw error;
  }
};
// ✅ Upload Image API
export const uploadImageApi = async (file: File): Promise<string> => {
  const formData = new FormData();
  formData.append("image", file); // ⚠ backend field name = image

  const { data } = await axiosInstance.post("/uplordDoc", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  // ⚠ adjust according to your backend response
  return data?.data?.url || data?.url || data?.data;
};
